import { AUCTION_CONTRACT } from "@/utils/constant"
import ERC20_ABI from "../abi/Auction.json"
import useContract from "./useContract"

export default function useAuctionContract(tokenAddress?: string) {
  return useContract(tokenAddress || AUCTION_CONTRACT, ERC20_ABI)
}
